import React, { useState } from "react";
import { Datagrid, Filter, List, TextField, TextInput, ReferenceField } from "react-admin";

const SpecialistSalesReportFilter = (props) => (
  <Filter {...props}>
    <TextInput label="نام" source="name" />
    <TextInput label="شماره تلفن" source="phoneNumber" />
    <TextInput label="ایمیل" source="email" />
  </Filter>
);

export const SpecialistSalesReportList = (props) => (
  <List {...props} filters={<SpecialistSalesReportFilter />}>
    <Datagrid rowClick="show">
      <ReferenceField link="show" label="کاربر متخصص" source="objectId" reference="user">
        <TextField source="name" />
      </ReferenceField>
      <TextField source="phoneNumber" label="شماره تلفن" />
      <TextField source="countOfSales" label="تعداد فروش پکیج ها" />
      <TextField source="averageRating" label="میانگین امتیاز" />
      <TextField source="totalMessages" label="تعداد پیام ارسالی" />
    </Datagrid>
  </List>
);
